module.exports = __webpack_public_path__ + "76b5d893f456b6cae68d8bc62ea75d59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 291
// module chunks = 5